import { useMutation } from '@tanstack/react-query';
import { checkDuplicatePatient } from '../patients/api';

/**
 * Explicitly triggered by the "Check for existing records" button, not an
 * idle background read — a mutation is the right primitive even though
 * nothing is written server-side, because the input varies per call and the
 * result is never reused from cache.
 */
export function useDuplicateCheck() {
  return useMutation({ mutationFn: checkDuplicatePatient });
}
